$(window).on('load', function () {
    $('[data-background]').each(function () {
        var src = encodeURI($(this).attr('data-background'));
        $(this).css('background-image', 'url("' + src + '")');
    })
});